/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import React, { useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';

import Model from '@tripian/model';
import { api } from '@tripian/core';
import { FormTemplateLogin } from '@tripian/react';

import config from '../../config';
import { LOGIN, USE_TRIP_URL } from '../../constants/ROUTER_PATH_TITLE';
import LOCAL_STORAGE_KEYS from '../../constants/LOCAL_STORAGE_KEYS';

import useAuth from '../../hooks/useAuth';
import useUser from '../../hooks/useUser';

const LoginPage = () => {
  const { isLoggedIn, loggedIn } = useAuth();
  const { user, userFetch } = useUser();

  const history = useHistory();
  const location = useLocation();

  document.title = LOGIN.TITLE;

  useEffect(() => {
    // Already logged in. Redirect to where came from or home
    if (isLoggedIn && user) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const from: any = location.state || { from: { pathname: '/' } };
      history.replace(from.from);

      // HIDE LOGIN for butter redirect to hash login
    } else if (config.HIDE_LOGIN) history.replace(USE_TRIP_URL.PATH);
    else {
      // Do nothing
    }
  }, [isLoggedIn, history, location, user]);

  const callbackSuccessLogin = (token: Model.Token) => {
    if (!config.DONT_SAVE_TOKEN) localStorage.setItem(`${LOCAL_STORAGE_KEYS.TOKEN}-${config.name}`, JSON.stringify(token));
    loggedIn();
    userFetch();
  };

  if (isLoggedIn) return null;

  return (
    <>
      <div className="full-center">
        <div className="login-form-wrapper">
          <FormTemplateLogin login={api.loginEmail} successLogin={callbackSuccessLogin} reCaptchaSiteKey="6LcSweAUAAAAAJKsnLlDnnUTLFG6cspHMI1BJCfP" showCaptcha={config.NODE_ENV === 'production'} />
          <br />
          {config.SHOW_REGISTER ? (
            <button
              type="button"
              onClick={() => {
                history.push('/register');
              }}
            >
              Register
            </button>
          ) : null}
        </div>
      </div>
    </>
  );
};

export default LoginPage;
